import React, { useState } from "react";
import {
  useBindAdminContact,
  useBindedAdminContacts,
  useGetUser,
  useUnbindAdminContact,
} from "../../api/admin-contact/use-admin-contact";
import { changePassword } from "../../api/auth/change-password/use-change-password";
import TitlePage from "../../components/section/TitlePage/Titlepage";
import Button from "../../components/ui/Button/Button";
import Modal from "../../components/ui/Modal/Modal";
import FieldBox from "../../utils/Form/ui/FieldBox";
import AdminContact from "./Section/AdminContact";
import SelectRecipient from "./Section/SelectRecipient";

const AdministratorInformation = () => {
  const { data: bindedContactList } = useBindedAdminContacts();
  const { data: userData } = useGetUser();
  const { mutate: unbindAdminContact } = useUnbindAdminContact();
  const { mutate: bindAdminContact } = useBindAdminContact();
  const [contact, setContact] = useState(bindedContactList?.data);
  const [triggerCloseModal, setTriggerCloseModal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [inputPwd, setInputPwd] = useState({
    currentPwd: "",
    newPwd: "",
    confirmNewPwd: "",
  });
  const [inputErrors, setInputErrors] = useState({
    currentPwd: false,
    newPwd: false,
    confirmNewPwd: false,
  });
  const handleCheck = () => {
    setIsChecked(!isChecked);
  };

  React.useEffect(() => {
    if (triggerCloseModal === true) {
      setTriggerCloseModal(false);
    }
  }, [triggerCloseModal]);

  const onChangePwd = (e, id) => {
    const value = e.target.value;
    // const regexPwd = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,20}$/;
    const regex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

    setInputPwd({ ...inputPwd, [id]: value });
    if (id === "currentPwd") {
      setInputErrors({
        ...inputErrors,
        currentPwd: false,
      });
    }
    if (id === "newPwd") {
      if (!regex.test(value)) {
        setInputErrors({
          ...inputErrors,
          newPwd: true,
        });
      } else {
        setInputErrors({
          ...inputErrors,
          newPwd: false,
        });
      }
    }
    if (id === "confirmNewPwd") {
      if (value !== inputPwd?.newPwd) {
        setInputErrors({
          ...inputErrors,
          confirmNewPwd: true,
        });
      } else {
        setInputErrors({
          ...inputErrors,
          confirmNewPwd: false,
        });
      }
    }
  };
  const isFilledPwd = Object.values(inputPwd).every((val) => val !== "");
  const handleSubmitChangePassword = async (e) => {
    e.preventDefault();
    const res = await changePassword({
      currentPassword: inputPwd?.currentPwd,
      newPassword: inputPwd?.newPwd,
    });
    if (res?.status === 200) {
      setIsSuccess(true);
    }
    if (res?.response?.data?.error?.code === "auth/invalid-password") {
      setInputErrors({
        ...inputErrors,
        currentPwd: true,
      });
    }
  };

  const handleSubmitContact = async () => {
    const payload = contact?.map((res) => res?.id);
    const currentIds = bindedContactList?.data?.map((res) => res?.id);
    if (bindedContactList?.data !== contact) {
      await unbindAdminContact({
        ids: currentIds,
      });
      await bindAdminContact({
        ids: payload,
      });
    } else {
      await bindAdminContact({
        ids: payload,
      });
    }
  };

  return (
    <div>
      <TitlePage title="설정" />
      <div className="mt-4">
        <p className="font-bold mb-4 text-title-black text-sm">관리자 정보</p>
        <FieldBox label="관리자 구분">
          <span className="p-2">최고관리자</span>
        </FieldBox>
        <FieldBox label="아이디">
          <span className="p-2">{userData?.data?.username}</span>
        </FieldBox>
        <FieldBox isLast={!isChecked} label="비밀번호">
          <div className="flex items-center h-5">
            <input
              id="changePwd"
              onClick={handleCheck}
              type="checkbox"
              className="accent-primary-blue ml-2 cursor-pointer"
            />
            <label htmlFor="changePwd" className="p-2">
              변경
            </label>
          </div>
        </FieldBox>
        {isChecked && (
          <form>
            <FieldBox
              isLast
              label={
                <div>
                  <p className="mb-1">비밀번호 변경</p>
                  <Button
                    type="submit"
                    onClick={handleSubmitChangePassword}
                    isDisabled={
                      !isFilledPwd || Object.values(inputErrors).includes(true)
                    }
                    text="변경사항 저장"
                    primary
                    paddingButton="p-[3px]"
                    width="w-[6rem]"
                  />
                </div>
              }
            >
              <div className="flex items-center ml-2">
                <div className="flex items-center w-1/2 flex-none">
                  <p className="flex-none w-28">현재 비밀번호</p>
                  <input
                    value={inputPwd?.currentPwd}
                    onChange={(e) => onChangePwd(e, "currentPwd")}
                    type="password"
                    className={`border ${
                      inputErrors?.currentPwd === true
                        ? "border-[#e80000]"
                        : "border-border-grey"
                    } flex-none h-7 w-48 py-0.5 px-2 outline-none rounded-[4px]`}
                  />

                  {inputErrors?.currentPwd === true ? (
                    <span className="flex-none ml-3 text-[#e80000]">
                      현재 비밀번호가 일치하지 않습니다.
                    </span>
                  ) : null}
                </div>
              </div>
              <div className="flex items-center ml-2 mt-2">
                <div className="flex items-center w-1/2 flex-none">
                  <p className="flex-none w-28">비밀번호 변경</p>
                  <input
                    value={inputPwd?.newPwd}
                    onChange={(e) => onChangePwd(e, "newPwd")}
                    type="password"
                    className={`border ${
                      inputErrors?.newPwd === true
                        ? "border-[#e80000]"
                        : "border-border-grey"
                    } flex-none  h-7 w-48 py-0.5 px-2 outline-none rounded-[4px]`}
                  />
                  {inputErrors?.newPwd === true ? (
                    <span className="flex-none ml-3 text-[#e80000]">
                      비밀번호는 영문 대문자, 영문 소문자, 숫자, 특수문자 중
                      2가지 이상을 조합한 8~20로 입력해주세요.
                    </span>
                  ) : null}
                </div>
              </div>
              <div className="flex items-center ml-2 mt-2">
                <div className="flex items-center w-1/2 flex-none">
                  <p className="flex-none w-28">비밀번호 변경 확인</p>
                  <input
                    value={inputPwd?.confirmNewPwd}
                    onChange={(e) => onChangePwd(e, "confirmNewPwd")}
                    type="password"
                    className={`border ${
                      inputErrors?.confirmNewPwd === true
                        ? "border-[#e80000]"
                        : "border-border-grey"
                    } flex-none  h-7 w-48 py-0.5 px-2 outline-none rounded-[4px]`}
                  />
                  {inputErrors?.confirmNewPwd === true ? (
                    <span className="flex-none ml-3 text-[#e80000]">
                      입력하신 비밀번호가 일치하지 않습니다.
                    </span>
                  ) : null}
                </div>
              </div>
            </FieldBox>
          </form>
        )}
      </div>
      <div className="mt-6">
        <p className="font-bold mb-4 text-title-black text-sm">
          정보 수신 설정
        </p>
        <FieldBox label="발송 유형">
          <span className="p-2">SMS 발송</span>
        </FieldBox>
        <FieldBox label="연락처 등록">
          <Modal
            maxWidth="max-w-[40rem]"
            hasClose={true}
            padding="py-4"
            paddingTitle={`px-6`}
            title="관리자 연락처 관리"
            description={<AdminContact />}
            hasCancel={false}
            hasSubmit={false}
          >
            <button
              disabled={isChecked}
              className={`${
                isChecked
                  ? "bg-disable-grey text-white"
                  : "bg-gradient-to-b from-white via-primary-white to-background-grey"
              } border border-button-grey px-3 py-1 rounded-[4px] ml-2`}
            >
              {" "}
              관리자 연락처 관리
            </button>
          </Modal>
        </FieldBox>
        <FieldBox
          padding="p-0"
          isLast
          label={
            <>
              <div className={`${contact?.length > 0 && "h-24 mt-8"}`}>
                관리자 발송 대상 <br />
                {contact?.length > 0 && (
                  <Button
                    onClick={handleSubmitContact}
                    paddingButton="p-1"
                    width="w-auto"
                    className="mt-1"
                    text="변경사항 저장"
                    primary
                  />
                )}
              </div>
            </>
          }
        >
          <div
            className={`flex items-center border-primary-grey ${
              contact?.length > 0 && "border-b"
            }  p-2`}
          >
            <Modal
              hasClose={true}
              maxWidth="max-w-[40rem]"
              description={
                <SelectRecipient
                  contact={contact}
                  setContact={setContact}
                  setTriggerCloseModal={setTriggerCloseModal}
                />
              }
              hasCancel={false}
              hasSubmit={false}
              title="수신 대상자 선택"
              padding="py-4"
              paddingTitle={`px-6`}
              triggerClose={triggerCloseModal}
            >
              <button
                disabled={isChecked}
                className={`${
                  isChecked
                    ? "bg-disable-grey text-white"
                    : "bg-gradient-to-b from-white via-primary-white to-background-grey"
                } border border-button-grey mr-2 px-3 py-1 rounded-[4px] ml-2`}
              >
                대상선택
              </button>
            </Modal>
            <p className="text-[#e80000] font-bold">
              발송 대상 : 총 {contact?.length}명
            </p>
          </div>

          {contact?.length > 0 ? (
            <div className="p-2">
              {contact?.map((res, index) => {
                return (
                  <span>
                    {res?.name}
                    {`(${res?.phone})`}{" "}
                    {index < contact?.length - 1 ? ", " : ""}
                  </span>
                );
              })}
            </div>
          ) : (
            ""
          )}
        </FieldBox>
      </div>
      {isSuccess && (
        <Modal
          isOpenFromOutside={isSuccess}
          setIsOpenFromOutside={setIsSuccess}
          description="비밀번호가 변경되었습니다."
          hasCancel={false}
        />
      )}
    </div>
  );
};

export default AdministratorInformation;
